import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import DiscountDetail from "@/pages/DiscountDetail";
import Submit from "@/pages/Submit";
import About from "@/pages/About";
import Admin from "@/pages/Admin";

function App() {
    return (
        <div className="min-h-screen bg-base text-[#e8eef5]">
            <BrowserRouter>
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/browse" element={<Browse />} />
                        <Route path="/discount/:id" element={<DiscountDetail />} />
                        <Route path="/submit" element={<Submit />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </main>
                <Footer />
            </BrowserRouter>
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0e1319",
                        border: "1px solid rgba(255,255,255,0.1)",
                        color: "#e8eef5",
                        borderRadius: "2px",
                    },
                }}
            />
        </div>
    );
}

export default App;
